import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

export function showSuccessToast(
    message: string,
    messageService: MessageService,
    translateService: TranslateService
) {
    messageService.add({
        severity: 'success',
        summary: translateService.instant('Success'),
        detail: message,
        key: 'tc',
    });
}

export function showErrorToast(
    message: string,
    messageService: MessageService,
    translateService: TranslateService
) {
    messageService.add({
        severity: 'error',
        summary: translateService.instant('Error'),
        detail: message,
        key: 'tc',
    });
}
